import { useRecoilCallback } from 'recoil'
import {
  canvasPageIdAtom,
  itemAtomFamily,
  unsavedChangesAtom,
} from '@/atoms/_editorAtoms'
import {
  editorTextBoxDraftsAtom,
  editorTextBoxPendingDeletesAtom,
} from '@/atoms/editorTextBoxAtoms'
import {
  editorAnchorPageId,
  isEditorTextBoxItem,
} from '@/utils/editor-text-box/editorTextBoxAdapter'

export const useEditorTextBoxDelete = () =>
  useRecoilCallback(
    ({ snapshot, set }) =>
      async (itemId: string): Promise<boolean> => {
        const item = await snapshot.getPromise(itemAtomFamily(itemId))
        if (!isEditorTextBoxItem(item)) return false
        const drafts = await snapshot.getPromise(editorTextBoxDraftsAtom)
        const draft = drafts[itemId] ?? null
        const canvasPageId = await snapshot.getPromise(canvasPageIdAtom)
        const pageId =
          draft !== null ? editorAnchorPageId(draft.anchor) : canvasPageId
        if (!pageId) {
          console.error(
            `editor text box ${itemId}: delete could not resolve the box's page — its row is left alone`,
          )
          return false
        }
        set(editorTextBoxPendingDeletesAtom, (prev) => ({
          ...prev,
          [itemId]: pageId,
        }))
        if (draft !== null)
          set(editorTextBoxDraftsAtom, (prev) => {
            const { [itemId]: _dropped, ...rest } = prev
            void _dropped
            return rest
          })
        set(unsavedChangesAtom, true)
        return true
      },
    [],
  )

export default useEditorTextBoxDelete
